import React from 'react';
import { motion } from 'framer-motion';
import { FiStar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const testimonials = [
  {
    quote: "I needed a precise and timely appraisal for my property and EPO Valuation exceeded my expectations. Their certified experts delivered a clear, well-supported report that helped me make a confident decision. Their professionalism and straightforward process made everything seamless.",
    author: "John M.",
    role: "Client"
  },
  {
    quote: "As a commercial property investor, clarity and speed are crucial. EPO Valuation provided a comprehensive, unbiased valuation with a quick turnaround. Their expertise and commitment to my goals set them apart—I highly recommend their appraisal services.",
    author: "Sarah L.",
    role: "Client"
  },
  {
    quote: "From start to finish, the team at EPO Valuation provided exceptional service. Their communication was clear, they addressed all my questions, and the appraisal report arrived right on schedule. I now have total confidence in my property's value.",
    author: "David R.",
    role: "Client"
  },
  {
    quote: "I've worked with various appraisers over the years, but EPO Valuation truly stands out. Their reports are detailed and easy to understand, which made discussions with my lender effortless. The professionalism and integrity displayed throughout the process have made me a returning client.",
    author: "Lisa S.",
    role: "Real Estate Agent"
  }
];

const Testimonials = () => {
  return (
    <section className="section-padding bg-offwhite border-y border-gray-200">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Trusted by Texans</h2>
          <p className="text-muted text-lg">Don't just take our word for it. Hear from those who have experienced our dedicated service.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((item, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15, duration: 0.5 }}
              className="card-base p-8 flex flex-col h-full bg-white"
            >
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="w-4 h-4 fill-gold text-gold" />
                ))}
              </div>
              <p className="text-charcoal italic mb-8 flex-grow text-sm leading-relaxed">
                "{item.quote}"
              </p>
              <div className="mt-auto border-t border-gray-100 pt-4">
                <p className="font-bold text-navy font-serif">{item.author}</p>
                <p className="text-xs text-muted font-medium uppercase tracking-wider">{item.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;